/**
 *  komponenta pro štítky pro produkty
 */
import React, { Component, Fragment, useState } from "react";
import AddEditPerformanceCategory from "./AddEditPerformanceCategory";
import ModalNotification from "../../../GlobalComponents/ModalNotification";
import Notification from "../../../Library/notification";
import { useQuery, useMutation, useApolloClient } from "@apollo/client";
import { GET_PERFORMANCE_CATEGORIES, DELETE_PERFORMANCE_CATEGORIES } from "../Queries/performanceCategory";
import Loading from "../../../GlobalComponents/Loading";
import Error from "../../../GlobalComponents/Error";
import edit from "../../../Public/Images/edit.svg";
import NoItems from "../../../GlobalComponents/NoItems";
import Helper from "../../../Library/helper";
import translate from "../../Translations/index";
import SearchInput from "../../General/Components/SearchInput";

const PerformanceCategories = (props) => {
    const client = useApolloClient();
    //zjistime jestli ma prihlaseny administrator spravna prava
    const helper = new Helper();
    helper.checkAdminRights({ ...props, client }, ["1", "2"]);

    const [searchQuery, setSearchQuery] = useState("");
    const [listVariables, setListVariables] = useState({
        filters: {
            offset: 0,
            limit: 50,
            searchQuery: "",
            sportID: 0,
            lang: translate.locale,
        },
        lang: translate.locale,
    });

    const [selectedPerformanceCategories, setSelectedPerformanceCategories] = useState([]);
    const [showDeleteNotifi, setShowDeleteNotifi] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [selectedPerformanceCategoryID, setSelectedPerformanceCategoryID] = useState(0);
    const {
        loading,
        error: getError,
        data: performanceCategoryListData,
        fetchMore,
        refetch,
    } = useQuery(GET_PERFORMANCE_CATEGORIES, {
        variables: listVariables,
        fetchPolicy: "cache-and-network",
    });

    const [deletePerformanceCategory, { data, loading: deleteLoading, error: deleteError }] = useMutation(DELETE_PERFORMANCE_CATEGORIES, {
        update(cache, response) {
            let notify = new Notification();
            notify.setNotification(translate.t("SuccessFullyDeleted"));
            setShowDeleteNotifi(false);
            console.log(performanceCategoryListData);
            refetch({ filters: { ...listVariables.filters, limit: performanceCategoryListData.allPerformanceCategories.length } });
        },
        onError(err) {
            const helper = new Helper();
            let notify = new Notification();
            notify.setNotification(!!err.message ? err.message : err.toString(), "danger");
        },
    });

    const openCloseModal = (open, performanceCategoryID) => {
        setSelectedPerformanceCategoryID(performanceCategoryID);
        setShowAdd(open);
    };

    /**
     * smazání štítků
     * @param {*} deletePerformanceCategories funkce, která posílá data na server
     * @param {*} performanceCategoryID ID performanceCategoryu
     */

    const initiateDeletePerformanceCategory = (e, performanceCategoryID) => {
        var checked = e.target.checked;
        var arr = [...selectedPerformanceCategories];

        if (!checked) {
            for (let i in selectedPerformanceCategories) {
                if (selectedPerformanceCategories[i] == performanceCategoryID) {
                    arr.splice(i, 1);
                }
            }
        } else {
            arr = [performanceCategoryID, ...arr];
        }

        setSelectedPerformanceCategories(arr);
    };

    const delPerformanceCategory = (action) => {
        if (action) {
            let performanceCategoryIDs = selectedPerformanceCategories.join(",");

            deletePerformanceCategory({
                variables: {
                    performanceCategoryIDs: performanceCategoryIDs,
                },
            });
        }
        setShowDeleteNotifi(false);
        //this.setState(INITIAL_STATE);
    };

    const showDelNotifi = () => {
        if (selectedPerformanceCategories.length > 0) {
            setShowDeleteNotifi(true);
        } else {
            let notify = new Notification();
            notify.setNotification(translate.t("ItemNotSelected"), "danger");
        }
    };

    if (getError || deleteError) {
        var error = getError ? getError : deleteError;
        const helper = new Helper();
        error = "ERROR: " + helper.getApolloErrorText(error);
    }
    return (
        <div id="settings" className="whole-container">
            <div className="row">
                <div className="col-sm one">
                    <div className="card main">
                        <div className="card-header d-flex align-items-center">
                            {translate.t("PerformanceCategoryList")}
                            <button className="btn btn-primary btn-thiner ml-auto" onClick={() => openCloseModal(true, 0)}>
                                {translate.t("Add")}
                            </button>
                            <button className="btn btn-danger btn-thiner ml-2" onClick={() => showDelNotifi()}>
                                {translate.t("DeleteSelected")}
                            </button>
                        </div>
                        <div className={`d-flex px-3 py-2 bg-light border-bottom align-items-center`}>
                            <div className="form-group mr-3">
                                <div className="text-nowrap fs12">{translate.t("Sport")}</div>
                                <select
                                    className="form-control form-control-sm"
                                    value={listVariables.filters.sportID}
                                    onChange={(e) => setListVariables({ ...listVariables, filters: { ...listVariables.filters, sportID: e.target.value } })}
                                >
                                    <option value={0}>-- {translate.t("Choose")} --</option>
                                    {performanceCategoryListData?.sports.map((item, index) => (
                                        <option key={index} value={item.sportID}>
                                            {item.title}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group ml-auto">
                                <div className="text-nowrap fs12">{translate.t("Search")}</div>
                                <SearchInput
                                    className={"form-control form-control-sm "}
                                    value={searchQuery}
                                    onChange={(text) => {
                                        setListVariables({ ...listVariables, filters: { ...listVariables.filters, searchQuery: text, offset: 0 } });
                                    }}
                                    textChanged={(text) => {
                                        setSearchQuery(text);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="card-body">
                            {!error ? (
                                <div>
                                    <div className="data-list">
                                        <div className="data-list-item header">
                                            <div className="data-list-item-content">
                                                <div>{translate.t("PerformanceCategoryTitle")}</div>
                                                <div className="text-center">{translate.t("Sport")}</div>
                                                <div className="text-right">{translate.t("Options")}</div>
                                            </div>
                                        </div>
                                        <Fragment>
                                            {performanceCategoryListData &&
                                                performanceCategoryListData.allPerformanceCategories &&
                                                performanceCategoryListData.allPerformanceCategories.map((item, index) => {
                                                    var checked = false;
                                                    for (let i in selectedPerformanceCategories) {
                                                        if (selectedPerformanceCategories[i] == item.performanceCategoryID) checked = true;
                                                    }

                                                    return (
                                                        <div key={index} className="data-list-item-content">
                                                            <div>{item.title}</div>
                                                            <div className="text-center">{item?.sport?.title}</div>
                                                            <div className="text-right">
                                                                <img
                                                                    onClick={() => openCloseModal(true, item.performanceCategoryID)}
                                                                    className="edit-icon"
                                                                    src={edit}
                                                                />
                                                                <input
                                                                    className="delete-checked"
                                                                    type="checkbox"
                                                                    name="deletePerformanceCategory[]"
                                                                    checked={checked}
                                                                    onChange={(e) => initiateDeletePerformanceCategory(e, item.performanceCategoryID)}
                                                                />
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </Fragment>
                                    </div>
                                    {!loading ? (
                                        <Fragment>
                                            {!loading && (
                                                <>
                                                    {!!performanceCategoryListData?.allPerformanceCategories?.length ? (
                                                        <>
                                                            {performanceCategoryListData.allPerformanceCategories.length <
                                                                performanceCategoryListData.performanceCategoryListCount && (
                                                                <div className="text-center p-5">
                                                                    <button
                                                                        className="btn btn-primary"
                                                                        onClick={() =>
                                                                            fetchMore({
                                                                                variables: {
                                                                                    ...listVariables,
                                                                                    filters: {
                                                                                        ...listVariables.filters,
                                                                                        offset: performanceCategoryListData.allPerformanceCategories.length,
                                                                                    },
                                                                                },
                                                                                updateQuery: (prev, { fetchMoreResult }) => {
                                                                                    if (!fetchMoreResult) return prev;
                                                                                    return Object.assign({}, prev, {
                                                                                        allPerformanceCategories: [
                                                                                            ...prev.allPerformanceCategories,
                                                                                            ...fetchMoreResult.allPerformanceCategories,
                                                                                        ],
                                                                                    });
                                                                                },
                                                                            })
                                                                        }
                                                                    >
                                                                        {" "}
                                                                        {translate.t("LoadMore")}{" "}
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <NoItems text={translate.t("NoItemsAddedYet")} />
                                                    )}
                                                </>
                                            )}
                                        </Fragment>
                                    ) : (
                                        <Loading />
                                    )}
                                </div>
                            ) : (
                                <Fragment>{error && <Error text={error} />}</Fragment>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {showAdd && (
                <AddEditPerformanceCategory
                    openCloseModal={openCloseModal}
                    selectedPerformanceCategoryID={selectedPerformanceCategoryID}
                    updated={() =>
                        refetch({
                            filters: {
                                ...listVariables.filters,
                                limit:
                                    listVariables.filters.limit > performanceCategoryListData.allPerformanceCategories.length
                                        ? listVariables.filters.limit
                                        : performanceCategoryListData.allPerformanceCategories.length,
                            },
                        })
                    }
                />
            )}
            {showDeleteNotifi && <ModalNotification yesNo={true} text={translate.t("RemoveItems?")} callback={delPerformanceCategory} />}
        </div>
    );
};

export default PerformanceCategories;
